import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Dropdown from 'react-bootstrap/Dropdown';
import { getSettings } from '../../util/getSettings';
import { Filters } from '../../util/constants';
import axios from 'axios';
import { 
  setRelativeUrl, 
  setSelectedState, 
  setSelectedMetro, 
  setSelectedCity, 
  updateMetros, 
  updateCities 
} from '../../redux/actions/mobileLocationFilters';


const StateFilterDropdown = (props) => { 
  const dropdownId = `${Filters.STATE_FILTER}_DROPDOWN`;
  const labels = getSettings(['century', 'labels'], true);
  const settings = getSettings(['century', 'settings']);
  const states = settings.searchRegionStates;
  const mobileLocFilters = useSelector((state) => state.mobileLocFilters);
  const dispatch = useDispatch()

  const onSelectChange = (stateId) => {
    const newState = states.find((state) => state.ContentId == stateId);
    
    const getSearchRegionData = (stateId) => {
      axios.get('/api/search/getsearchregiondata?', {
        params: {
          contentId: stateId
        }
      })
      .then(function (response) {
        const data = {...response.data}
        console.log(data)
        dispatch(setRelativeUrl(newState.RelativeURL));
        dispatch(setSelectedState(newState.StateName));
        dispatch(updateMetros(data.Metros));
        dispatch(updateCities(data.Cities));
        dispatch(setSelectedMetro(''));
        dispatch(setSelectedCity(''));
        props.setFetching(false);
      })
      .catch(function (error) {
        console.log(error);
      }) 
    };
  
    getSearchRegionData(stateId);
  }
  
  return (
    <div className="dropdown">
      <label className="filter-title">{labels.stateFilterLabel}</label>
      <Dropdown onSelect={onSelectChange}>
        <Dropdown.Toggle variant="success" id="state-mobile-dropdown" aria-controls={dropdownId}>
          {mobileLocFilters.selectedState}
        </Dropdown.Toggle>
        <Dropdown.Menu id={dropdownId}>
          {states.map((state, index) => (
            <Dropdown.Item key={index} eventKey={state.ContentId}>
              {state.StateName}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default StateFilterDropdown;